<template>
	<div class="container priorities">
		<div class="row justify-content-md-center">
			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="flag" class="primario" /> Não visualizado
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="flag" class="azul" /> Irrelevante
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="flag" class="atencao" /> Baixa
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="flag" class="vermelho" /> Média
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="flag" class="preto" /> Alta
			</div>
		</div>
	</div>
</template>

<script>
	export default { name: "record-priority" }
</script>

<style>
	.priorities {
		margin-bottom: 5px;
	}
</style>